document.addEventListener('turbolinks:load', () => {
  $(document).ready(() => {
    $('#close-promotion-banner').click((e) => {
      e.preventDefault();

      const $banner = $('#promotion-banner');
      const text = $('#promotion-banner').text();
      const expireDate = new Date();

      expireDate.setTime(expireDate.getTime() + (14 * 24 * 60 * 60 * 1000)); // cookie expiry 2 weeks

      document.cookie = `promotion-banner=${encodeURIComponent(text)}; expires=${expireDate.toUTCString()}; path=/`;

      $banner.hide();
    });
  });
});
